export const STORE_PLANT_ITEMS = 'STORE_PLANT_ITEMS';
export const ADD_PLANT_ITEM = 'ADD_PLANT_ITEM';
export const STORE_PLANT_DETAILS = 'STORE_PLANT_DETAILS';
export const STORE_ASSOCIATED_DESIGN = 'STORE_ASSOCIATED_DESIGN';
export const STORE_RELATED_DETAILS = 'STORE_RELATED_DETAILS';
export const RESET_ASSOCIATED_DESIGN = 'RESET_ASSOCIATED_DESIGN';
export const RESET_RELATED_DETAILS = 'RESET_RELATED_DETAILS';
export const REMOVE_PLANT_ITEM = 'REMOVE_PLANT_ITEM';

export const storePlantItems = (data) => ({
  type: STORE_PLANT_ITEMS,
  payload: { ...data },
});

export const addPlantItem = (data) => ({
  type: ADD_PLANT_ITEM,
  payload: { ...data },
});

export const storePlantDetails = (data, index) => ({
  type: STORE_PLANT_DETAILS,
  payload: { data, index },
});

export const storeAssociatedDesign = (data, index) => ({
  type: STORE_ASSOCIATED_DESIGN,
  payload: { data, index },
});

export const storeRelatedDetails = (data, index) => ({
  type: STORE_RELATED_DETAILS,
  payload: { data, index },
});

export const resetAssociatedDesign = (index) => ({
  type: RESET_ASSOCIATED_DESIGN,
  payload: { index },
});

export const resetRelatedDetails = (index) => ({
  type: RESET_RELATED_DETAILS,
  payload: { index },
});

export const removePlantItem = (index) => ({
  type: REMOVE_PLANT_ITEM,
  payload: { index },
});
